{
  "id": "atlanteans",
  "name": {
    "pt-BR": "Atlantes",
    "en": "Atlanteans"
  },
  "icon": "ui/pantheon-atlanteans",
  "workers": ["citizen", "citizen-hero"],
  "townCenter": "town-center",
  "start": {
    "resources": {
      "food": 275,
      "wood": 250,
      "gold": 75
    },
    "units": {
      "citizen": 2,
      "oracle": 3
    },
    "buildings": {
      "town-center": 1,
      "sentry-tower": 4
    },
    "popCap": 15
  },
  "favor": {
    "type": "oracles",
    "unit": "oracle",
    "defaultRate": 2,
    "min": 0.6,
    "max": 3.4,
    "heroMultiplier": 1.44,
    "heroUnit": "oracle-hero",
    "meta": {
      "source": "Game files 19.17020 (proto.xml Oracle/OracleHero AutoGatherFavor and AutoLOS)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Per Oracle: favor/s = 0.01 + modifymultiplier x (bonusLOS/100)^2 (formula: wiki; parameters: files). Oracle multiplier 0.75, cap 25 -> 0.6..3.41 favor/min; Oracle Hero 0.80, cap 30 -> max 4.92 (x1.44). bonusLOS grows +1/s while still (AutoLOS, decay 0.3). 2.0/min default is the owner's planning value. Overlapping LOS is an engine rule (not in these files). No favor cap anywhere in the files (no favorCap)."
    }
  },
  "gods": ["kronos", "oranos", "gaia"],
  "ageUps": [
    {
      "pantheon": "atlanteans",
      "to": "classical",
      "cost": {
        "food": 400
      },
      "time": 60,
      "at": "town-center",
      "requiresAnyOf": [["temple"]],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ClassicalAge<minor>: 400 food, researchpoints 60, prereq 1 AbstractTemple (Temple)."
      }
    },
    {
      "pantheon": "atlanteans",
      "to": "heroic",
      "cost": {
        "food": 800,
        "gold": 500
      },
      "time": 75,
      "at": "town-center",
      "requiresAnyOf": [["armory"], ["market"]],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "HeroicAge<minor>: 800 food 500 gold, researchpoints 75, prereqs Armory or Market (OrPrereqs flag)."
      }
    },
    {
      "pantheon": "atlanteans",
      "to": "mythic",
      "cost": {
        "food": 1200,
        "gold": 1200
      },
      "time": 120,
      "at": "town-center",
      "requiresAnyOf": [["palace"]],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "MythicAge<minor>: 1200 food 1200 gold, researchpoints 120, prereq 1 Palace."
      }
    }
  ],
  "units": [
    {
      "id": "citizen",
      "name": {
        "pt-BR": "Cidadão",
        "en": "Citizen"
      },
      "icon": "units/atlanteans-citizen",
      "pantheon": "atlanteans",
      "tags": ["worker"],
      "cost": {
        "food": 85,
        "wood": 15
      },
      "pop": 2,
      "trainTime": 28,
      "trainedAt": ["town-center", "village-center"],
      "age": "archaic",
      "worker": {
        "gatherRates": {
          "hunt": 93,
          "herd": 84,
          "berries": 65.4,
          "farm": 65.4,
          "wood": 93,
          "gold": 79.2
        },
        "buildRate": 1.5,
        "canBuild": true,
        "needsDropsite": false
      },
      "promotion": {
        "to": "citizen-hero",
        "cost": {
          "food": 65,
          "wood": 10,
          "favor": 2
        },
        "time": 7
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Build limit 50 (shared with Citizen Heroes, BuildLimitSharedAtlantean). Gathers without drop sites. Starting queue auto-trains Citizens (major_gods.xml startingqueue)."
      },
      "fieldMeta": {
        "worker": {
          "source": "Game files 19.17020 (proto.xml VillagerAtlantean Gather/Build)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Gather (per second): Huntable 1.55, Herdable 1.40, WildCrops 1.09, AbstractFarm 1.09, WoodResource 1.55, GoldResource 1.32 (x60 = per minute). Build: Building 1.5, Settlement/VillageCenter 1.25 (Town Center and Village Center buildTime are scaled so a Citizen takes 150/1.25 = 120 s). LogicalTypeGatherNoDropsite: no drop sites."
        },
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost. Gaia: VillagerAtlanteanToHero cost x0.75 BasePercent (food, wood, favor) -> 48.75f 7.5w 1.5 favor."
        },
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml VillagerAtlantean trainpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "trainpoints 28. Conflicts with the owner's measurement (~30 s, which this project used before); the file wins. No Atlantean tech, god or Town Center/Village Center train-rate effect changes it (Village Center: no trainingrate entry, so the wiki's '25% slower' is not in the files)."
        }
      },
      "plural": {
        "pt-BR": "Cidadãos",
        "en": "Citizens"
      }
    },
    {
      "id": "citizen-hero",
      "name": {
        "pt-BR": "Cidadão (Herói)",
        "en": "Citizen (Hero)"
      },
      "icon": "units/atlanteans-citizen-hero",
      "pantheon": "atlanteans",
      "tags": ["worker", "hero"],
      "cost": {
        "food": 150,
        "wood": 25,
        "favor": 2
      },
      "pop": 2,
      "trainTime": 0,
      "trainedAt": [],
      "age": "archaic",
      "worker": {
        "gatherRates": {
          "hunt": 102,
          "herd": 91.8,
          "berries": 71.4,
          "farm": 71.4,
          "wood": 102,
          "gold": 87
        },
        "buildRate": 1.65,
        "canBuild": true,
        "needsDropsite": false
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trained directly: obtained by promoting a Citizen (see citizen.promotion). Cost = VillagerAtlanteanHero proto cost (150f 25w 2 favor = Citizen + promotion). Gaia starts with 2 (major_gods.xml)."
      },
      "plural": {
        "pt-BR": "Cidadãos (Heróis)",
        "en": "Citizens (Hero)"
      },
      "fieldMeta": {
        "worker": {
          "source": "Game files 19.17020 (proto.xml VillagerAtlanteanHero Gather/Build)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Gather (per second): Huntable 1.70, Herdable 1.53, WildCrops/AbstractFarm 1.19, Wood 1.70, Gold 1.45 (x60 = per minute). Build: Building 1.65, Settlement/VillageCenter 1.375. Theft of Fire: +20% BasePercent on all of these (its Build part only on 'Building', not Settlement/VillageCenter)."
        }
      }
    },
    {
      "id": "oracle",
      "name": {
        "pt-BR": "Oráculo",
        "en": "Oracle"
      },
      "icon": "units/atlanteans-oracle",
      "pantheon": "atlanteans",
      "tags": ["scout", "favor", "human"],
      "cost": {
        "food": 40,
        "gold": 60
      },
      "pop": 1,
      "trainTime": 11,
      "trainedAt": ["temple"],
      "age": "archaic",
      "promotion": {
        "to": "oracle-hero",
        "cost": {
          "food": 30,
          "gold": 45,
          "favor": 1
        },
        "time": 7
      },
      "favorRate": 2,
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Build limit 10. Generates favor while idle depending on its line of sight (see pantheon favor rule); favorRate is the planning default. The 3 starting Oracles spawn at 6, 10 and 14 s (major_gods.xml startingunits delay)."
      },
      "fieldMeta": {
        "favorRate": {
          "source": "Game files 19.17020 (proto.xml Oracle AutoGatherFavor/AutoLOS)",
          "checkedAt": "2026-10-18",
          "confidence": "medium",
          "note": "favor/s = 0.01 + 0.75 x (bonusLOS/100)^2 (formula from the wiki, parameters from the files: rate 0.01, modifymultiplier 0.75, modifyratecap 25; AutoLOS +1/s while still, decay 0.3) -> 0.6..3.41 favor/min. 2.0 is a planning default (owner)."
        },
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost."
        }
      }
    },
    {
      "id": "oracle-hero",
      "name": {
        "pt-BR": "Oráculo (Herói)",
        "en": "Oracle (Hero)"
      },
      "icon": "units/atlanteans-oracle-hero",
      "pantheon": "atlanteans",
      "tags": ["scout", "favor", "hero"],
      "cost": {
        "food": 30,
        "gold": 45,
        "favor": 1
      },
      "pop": 1,
      "trainTime": 11,
      "trainedAt": ["temple"],
      "age": "archaic",
      "favorRate": 2.88,
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Obtained by promoting an Oracle. After Sons of the Sun (Hyperion) every Oracle becomes an Oracle Hero and the Temple trains Oracle Heroes instead of Oracles (OracleHero favor cost set to 0): trainpoints 11, proto cost 30f 45g (1 favor before Sons of the Sun). The engine still lets you train plain Oracles after it."
      },
      "fieldMeta": {
        "favorRate": {
          "source": "project owner (sources)",
          "checkedAt": "2026-10-17",
          "confidence": "medium",
          "note": "2.0 default x 1.44 (Oracle Hero at full LOS 4.92 vs Oracle 3.41 favor/min, from proto.xml AutoGatherFavor: multiplier 0.80 cap 30 vs 0.75 cap 25)."
        }
      },
      "requires": ["sons-of-the-sun"]
    },
    {
      "id": "murmillo",
      "name": {
        "pt-BR": "Murmilo",
        "en": "Murmillo"
      },
      "icon": "units/atlanteans-murmillo",
      "pantheon": "atlanteans",
      "tags": ["infantry", "human"],
      "cost": {
        "food": 55,
        "gold": 30
      },
      "pop": 2,
      "trainTime": 14,
      "trainedAt": ["military-barracks"],
      "age": "classical",
      "promotion": {
        "to": "murmillo-hero",
        "cost": {
          "food": 40,
          "gold": 25,
          "favor": 2
        },
        "time": 7
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost."
        }
      }
    },
    {
      "id": "murmillo-hero",
      "name": {
        "pt-BR": "Murmilo (Herói)",
        "en": "Murmillo (Hero)"
      },
      "icon": "units/atlanteans-murmillo-hero",
      "pantheon": "atlanteans",
      "tags": ["infantry", "hero"],
      "cost": {
        "food": 95,
        "gold": 55,
        "favor": 2
      },
      "pop": 2,
      "trainTime": 0,
      "trainedAt": [],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trained directly: obtained by promoting a Murmillo (7 s). Cost = the hero proto cost (proto.xml)."
      }
    },
    {
      "id": "katapeltes",
      "name": {
        "pt-BR": "Katapeltes",
        "en": "Katapeltes"
      },
      "icon": "units/atlanteans-katapeltes",
      "pantheon": "atlanteans",
      "tags": ["infantry", "human"],
      "cost": {
        "food": 60,
        "gold": 35
      },
      "pop": 2,
      "trainTime": 10.5,
      "trainedAt": ["counter-barracks"],
      "age": "classical",
      "promotion": {
        "to": "katapeltes-hero",
        "cost": {
          "food": 45,
          "gold": 25,
          "favor": 2
        },
        "time": 7
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost."
        }
      }
    },
    {
      "id": "katapeltes-hero",
      "name": {
        "pt-BR": "Katapeltes (Herói)",
        "en": "Katapeltes (Hero)"
      },
      "icon": "units/atlanteans-katapeltes-hero",
      "pantheon": "atlanteans",
      "tags": ["infantry", "hero"],
      "cost": {
        "food": 105,
        "gold": 60,
        "favor": 2
      },
      "pop": 2,
      "trainTime": 0,
      "trainedAt": [],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trained directly: obtained by promoting a Katapeltes (7 s). Cost = the hero proto cost (proto.xml)."
      }
    },
    {
      "id": "turma",
      "name": {
        "pt-BR": "Turma",
        "en": "Turma"
      },
      "icon": "units/atlanteans-turma",
      "pantheon": "atlanteans",
      "tags": ["cavalry", "archer", "human"],
      "cost": {
        "wood": 45,
        "gold": 40
      },
      "pop": 2,
      "trainTime": 9.5,
      "trainedAt": ["counter-barracks"],
      "age": "classical",
      "promotion": {
        "to": "turma-hero",
        "cost": {
          "wood": 35,
          "gold": 30,
          "favor": 2
        },
        "time": 7
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost."
        },
        "trainTime": {
          "source": "Game files 19.17020 (proto.xml Turma trainpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "trainpoints 9.5. Conflicts with the owner's value (10 s, sources + measured) used before; the file wins."
        }
      }
    },
    {
      "id": "turma-hero",
      "name": {
        "pt-BR": "Turma (Herói)",
        "en": "Turma (Hero)"
      },
      "icon": "units/atlanteans-turma-hero",
      "pantheon": "atlanteans",
      "tags": ["cavalry", "archer", "hero"],
      "cost": {
        "wood": 80,
        "gold": 70,
        "favor": 2
      },
      "pop": 2,
      "trainTime": 0,
      "trainedAt": [],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trained directly: obtained by promoting a Turma (7 s). Cost = the hero proto cost (proto.xml)."
      }
    },
    {
      "id": "cheiroballista",
      "name": {
        "pt-BR": "Quirobalista",
        "en": "Cheiroballista"
      },
      "icon": "units/atlanteans-cheiroballista",
      "pantheon": "atlanteans",
      "tags": ["siege", "archer", "human"],
      "cost": {
        "wood": 115,
        "gold": 100
      },
      "pop": 4,
      "trainTime": 24,
      "trainedAt": ["counter-barracks"],
      "age": "classical",
      "promotion": {
        "to": "cheiroballista-hero",
        "cost": {
          "wood": 85,
          "gold": 75,
          "favor": 4
        },
        "time": 7
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost."
        }
      }
    },
    {
      "id": "cheiroballista-hero",
      "name": {
        "pt-BR": "Quirobalista (Herói)",
        "en": "Cheiroballista (Hero)"
      },
      "icon": "units/atlanteans-cheiroballista-hero",
      "pantheon": "atlanteans",
      "tags": ["siege", "archer", "hero"],
      "cost": {
        "wood": 200,
        "gold": 175,
        "favor": 4
      },
      "pop": 4,
      "trainTime": 0,
      "trainedAt": [],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trained directly: obtained by promoting a Cheiroballista (7 s). Cost = the hero proto cost (proto.xml)."
      }
    },
    {
      "id": "arcus",
      "name": {
        "pt-BR": "Arcus",
        "en": "Arcus"
      },
      "icon": "units/atlanteans-arcus",
      "pantheon": "atlanteans",
      "tags": ["archer", "human"],
      "cost": {
        "wood": 60,
        "gold": 35
      },
      "pop": 2,
      "trainTime": 16,
      "trainedAt": ["military-barracks"],
      "age": "heroic",
      "promotion": {
        "to": "arcus-hero",
        "cost": {
          "wood": 45,
          "gold": 25,
          "favor": 2
        },
        "time": 7
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost."
        }
      }
    },
    {
      "id": "arcus-hero",
      "name": {
        "pt-BR": "Arcus (Herói)",
        "en": "Arcus (Hero)"
      },
      "icon": "units/atlanteans-arcus-hero",
      "pantheon": "atlanteans",
      "tags": ["archer", "hero"],
      "cost": {
        "wood": 105,
        "gold": 60,
        "favor": 2
      },
      "pop": 2,
      "trainTime": 0,
      "trainedAt": [],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trained directly: obtained by promoting a Arcus (7 s). Cost = the hero proto cost (proto.xml)."
      }
    },
    {
      "id": "contarius",
      "name": {
        "pt-BR": "Contarius",
        "en": "Contarius"
      },
      "icon": "units/atlanteans-contarius",
      "pantheon": "atlanteans",
      "tags": ["cavalry", "human"],
      "cost": {
        "food": 75,
        "gold": 40
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["military-barracks"],
      "age": "heroic",
      "promotion": {
        "to": "contarius-hero",
        "cost": {
          "food": 55,
          "gold": 30,
          "favor": 3
        },
        "time": 7
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost."
        }
      }
    },
    {
      "id": "contarius-hero",
      "name": {
        "pt-BR": "Contarius (Herói)",
        "en": "Contarius (Hero)"
      },
      "icon": "units/atlanteans-contarius-hero",
      "pantheon": "atlanteans",
      "tags": ["cavalry", "hero"],
      "cost": {
        "food": 130,
        "gold": 70,
        "favor": 3
      },
      "pop": 3,
      "trainTime": 0,
      "trainedAt": [],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trained directly: obtained by promoting a Contarius (7 s). Cost = the hero proto cost (proto.xml)."
      }
    },
    {
      "id": "destroyer",
      "name": {
        "pt-BR": "Destruidor",
        "en": "Destroyer"
      },
      "icon": "units/atlanteans-destroyer",
      "pantheon": "atlanteans",
      "tags": ["infantry", "human"],
      "cost": {
        "food": 70,
        "gold": 60
      },
      "pop": 3,
      "trainTime": 7,
      "trainedAt": ["palace"],
      "age": "heroic",
      "promotion": {
        "to": "destroyer-hero",
        "cost": {
          "food": 55,
          "gold": 45,
          "favor": 3
        },
        "time": 7
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost."
        }
      }
    },
    {
      "id": "destroyer-hero",
      "name": {
        "pt-BR": "Destruidor (Herói)",
        "en": "Destroyer (Hero)"
      },
      "icon": "units/atlanteans-destroyer-hero",
      "pantheon": "atlanteans",
      "tags": ["infantry", "hero"],
      "cost": {
        "food": 125,
        "gold": 105,
        "favor": 3
      },
      "pop": 3,
      "trainTime": 0,
      "trainedAt": [],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trained directly: obtained by promoting a Destroyer (7 s). Cost = the hero proto cost (proto.xml)."
      }
    },
    {
      "id": "fanatic",
      "name": {
        "pt-BR": "Fanático",
        "en": "Fanatic"
      },
      "icon": "units/atlanteans-fanatic",
      "pantheon": "atlanteans",
      "tags": ["infantry", "human"],
      "cost": {
        "food": 75,
        "gold": 55
      },
      "pop": 3,
      "trainTime": 7,
      "trainedAt": ["palace"],
      "age": "mythic",
      "promotion": {
        "to": "fanatic-hero",
        "cost": {
          "food": 55,
          "gold": 40,
          "favor": 3
        },
        "time": 7
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Horns of Consecration (Rheia) enables Fanatics already in the Heroic Age (not modelled: age stays mythic)."
      },
      "fieldMeta": {
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Promotion tech <Unit>ToHero (techtype HeroPromotion): researchpoints 7, cost as listed (all promotion techs are made active by ArchaicAgeAtlantean). It is a transform command researched on the unit itself (proto.xml transformcommand), not a building queue. Heart of the Titans: HeroPromotion research time x0.25. Rheia's Gift does not change the favor cost."
        }
      }
    },
    {
      "id": "fanatic-hero",
      "name": {
        "pt-BR": "Fanático (Herói)",
        "en": "Fanatic (Hero)"
      },
      "icon": "units/atlanteans-fanatic-hero",
      "pantheon": "atlanteans",
      "tags": ["infantry", "hero"],
      "cost": {
        "food": 130,
        "gold": 95,
        "favor": 3
      },
      "pop": 3,
      "trainTime": 0,
      "trainedAt": [],
      "age": "mythic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not trained directly: obtained by promoting a Fanatic (7 s). Cost = the hero proto cost (proto.xml). With Horns of Consecration (Rheia) Fanatics are available in the Heroic Age."
      }
    },
    {
      "id": "fire-siphon",
      "name": {
        "pt-BR": "Sifão de Fogo",
        "en": "Fire Siphon"
      },
      "icon": "units/atlanteans-fire-siphon",
      "pantheon": "atlanteans",
      "tags": ["siege"],
      "cost": {
        "wood": 275,
        "gold": 180
      },
      "pop": 5,
      "trainTime": 19,
      "trainedAt": ["palace"],
      "age": "mythic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "fishing-ship",
      "name": {
        "pt-BR": "Navio Pesqueiro",
        "en": "Fishing Ship"
      },
      "icon": "units/atlanteans-fishing-ship",
      "pantheon": "atlanteans",
      "tags": ["ship", "worker"],
      "cost": {
        "wood": 50
      },
      "pop": 1,
      "trainTime": 18,
      "trainedAt": ["dock"],
      "age": "archaic",
      "worker": {
        "gatherRates": {
          "fish": 33
        },
        "canBuild": false,
        "needsDropsite": true
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Build limit 50. Gather rate 0.55 food/s (33/min), depends on distance to the Dock."
      }
    },
    {
      "id": "transport-ship",
      "name": {
        "pt-BR": "Navio de Transporte",
        "en": "Transport Ship"
      },
      "icon": "units/atlanteans-transport-ship",
      "pantheon": "atlanteans",
      "tags": ["ship"],
      "cost": {
        "wood": 110
      },
      "pop": 1,
      "trainTime": 19,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "bireme",
      "name": {
        "pt-BR": "Birreme",
        "en": "Bireme"
      },
      "icon": "units/atlanteans-bireme",
      "pantheon": "atlanteans",
      "tags": ["ship", "archer"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "fire-ship",
      "name": {
        "pt-BR": "Navio de Fogo",
        "en": "Fire Ship"
      },
      "icon": "units/atlanteans-fire-ship",
      "pantheon": "atlanteans",
      "tags": ["ship"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "siege-bireme",
      "name": {
        "pt-BR": "Birreme de Cerco",
        "en": "Siege Bireme"
      },
      "icon": "units/atlanteans-siege-bireme",
      "pantheon": "atlanteans",
      "tags": ["ship", "siege"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "nereid",
      "name": {
        "pt-BR": "Nereida",
        "en": "Nereid"
      },
      "icon": "units/atlanteans-nereid",
      "pantheon": "atlanteans",
      "tags": ["ship", "myth"],
      "cost": {
        "gold": 200,
        "favor": 15
      },
      "pop": 2,
      "trainTime": 12,
      "trainedAt": ["dock"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Available to all Atlanteans in the Heroic Age (Retold). One free Nereid spawns at a Dock on reaching the Heroic Age (HeroicAgeAtlantean CreateUnit, only if a Dock exists)."
      }
    },
    {
      "id": "man-o-war",
      "name": {
        "pt-BR": "Caravela",
        "en": "Man O' War"
      },
      "icon": "units/atlanteans-man-o-war",
      "pantheon": "atlanteans",
      "tags": ["ship", "myth"],
      "cost": {
        "food": 250,
        "favor": 15
      },
      "pop": 4,
      "trainTime": 10,
      "trainedAt": ["dock"],
      "age": "mythic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Available to all Atlanteans in the Mythic Age (Retold). One free Man O' War spawns at a Dock on reaching the Mythic Age (MythicAgeAtlantean CreateUnit, only if a Dock exists)."
      }
    },
    {
      "id": "llama-caravan",
      "name": {
        "pt-BR": "Caravana de Lhama",
        "en": "Llama Caravan"
      },
      "icon": "units/atlanteans-llama-caravan",
      "pantheon": "atlanteans",
      "tags": ["caravan"],
      "cost": {
        "food": 100,
        "wood": 25
      },
      "pop": 1,
      "trainTime": 18,
      "trainedAt": ["market"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Atlantean Caravan (in-game name Llama Caravan). Limit 60."
      }
    },
    {
      "id": "promethean",
      "name": {
        "pt-BR": "Prometeano",
        "en": "Promethean"
      },
      "icon": "units/atlanteans-promethean",
      "pantheon": "atlanteans",
      "tags": ["myth"],
      "cost": {
        "food": 90,
        "favor": 9
      },
      "pop": 2,
      "trainTime": 14,
      "trainedAt": ["temple"],
      "age": "classical",
      "requires": ["prometheus"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Splits into Promethean Offspring on death."
      }
    },
    {
      "id": "automaton",
      "name": {
        "pt-BR": "Autômato",
        "en": "Automaton"
      },
      "icon": "units/atlanteans-automaton",
      "pantheon": "atlanteans",
      "tags": ["myth"],
      "cost": {
        "gold": 90,
        "favor": 6
      },
      "pop": 2,
      "trainTime": 9,
      "trainedAt": ["temple"],
      "age": "classical",
      "requires": ["leto"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "caladria",
      "name": {
        "pt-BR": "Caladria",
        "en": "Caladria"
      },
      "icon": "units/atlanteans-caladria",
      "pantheon": "atlanteans",
      "tags": ["myth"],
      "cost": {
        "wood": 100,
        "gold": 25,
        "favor": 12
      },
      "pop": 2,
      "trainTime": 9,
      "trainedAt": ["temple"],
      "age": "classical",
      "requires": ["oceanus"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "servant",
      "name": {
        "pt-BR": "Servo",
        "en": "Servant"
      },
      "icon": "units/atlanteans-servant",
      "pantheon": "atlanteans",
      "tags": ["myth", "ship"],
      "cost": {
        "gold": 125,
        "favor": 12
      },
      "pop": 2,
      "trainTime": 15,
      "trainedAt": ["dock"],
      "age": "classical",
      "requires": ["oceanus"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Oceanus also gives one free Servant at a Dock on reaching the Classical Age (only if a Dock exists; not in freeUnitsOnAgeUp)."
      }
    },
    {
      "id": "satyr",
      "name": {
        "pt-BR": "Sátiro",
        "en": "Satyr"
      },
      "icon": "units/atlanteans-satyr",
      "pantheon": "atlanteans",
      "tags": ["myth"],
      "cost": {
        "wood": 250,
        "favor": 20
      },
      "pop": 3,
      "trainTime": 15,
      "trainedAt": ["temple"],
      "age": "heroic",
      "requires": ["hyperion"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "behemoth",
      "name": {
        "pt-BR": "Beemote",
        "en": "Behemoth"
      },
      "icon": "units/atlanteans-behemoth",
      "pantheon": "atlanteans",
      "tags": ["myth", "siege"],
      "cost": {
        "food": 250,
        "favor": 20
      },
      "pop": 4,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "heroic",
      "requires": ["rheia"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "stymphalian-bird",
      "name": {
        "pt-BR": "Pássaro de Estínfalo",
        "en": "Stymphalian Bird"
      },
      "icon": "units/atlanteans-stymphalian-bird",
      "pantheon": "atlanteans",
      "tags": ["myth"],
      "cost": {
        "wood": 200,
        "gold": 50,
        "favor": 25
      },
      "pop": 3,
      "trainTime": 10,
      "trainedAt": ["temple"],
      "age": "heroic",
      "requires": ["theia"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "dryad",
      "name": {
        "pt-BR": "Dríade",
        "en": "Dryad"
      },
      "icon": "units/atlanteans-dryad",
      "pantheon": "atlanteans",
      "tags": ["myth"],
      "cost": {
        "wood": 175
      },
      "pop": 0,
      "trainTime": 13,
      "trainedAt": ["hesperides-tree"],
      "age": "heroic",
      "requires": ["theia"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Costs no favor or population. Limit 5 per Hesperides Tree; the Hesperides god power also spawns 2 free Dryads."
      }
    },
    {
      "id": "argus",
      "name": {
        "pt-BR": "Argos",
        "en": "Argus"
      },
      "icon": "units/atlanteans-argus",
      "pantheon": "atlanteans",
      "tags": ["myth"],
      "cost": {
        "gold": 250,
        "favor": 25
      },
      "pop": 4,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "mythic",
      "requires": ["atlas"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "centimanus",
      "name": {
        "pt-BR": "Centimanos",
        "en": "Centimanus"
      },
      "icon": "units/atlanteans-centimanus",
      "pantheon": "atlanteans",
      "tags": ["myth"],
      "cost": {
        "gold": 300,
        "favor": 25
      },
      "pop": 4,
      "trainTime": 18,
      "trainedAt": ["temple"],
      "age": "mythic",
      "requires": ["helios"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "lampades",
      "name": {
        "pt-BR": "Lâmpade",
        "en": "Lampades"
      },
      "icon": "units/atlanteans-lampades",
      "pantheon": "atlanteans",
      "tags": ["myth"],
      "cost": {
        "gold": 200,
        "favor": 20
      },
      "pop": 4,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "mythic",
      "requires": ["hekate"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    }
  ],
  "buildings": [
    {
      "id": "town-center",
      "name": {
        "pt-BR": "Centro Urbano",
        "en": "Town Center"
      },
      "icon": "buildings/atlanteans-town-center",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 350,
        "gold": 350
      },
      "buildTime": 180,
      "popCap": 15,
      "age": "archaic",
      "trains": ["citizen"],
      "researches": [
        "masons",
        "architects",
        "fortified-town-center",
        "channels",
        "secrets-of-the-titans"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Players start with one. Build limit 1 in the Archaic Age (shared with the Village Center), unlimited from the Classical Age (ClassicalAgeAtlantean/ClassicalAgeGeneral BuildLimit -1). Ages are advanced here."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 150. Citizens build Settlements/Village Centers at rate 1.25 instead of their usual 1.5, so the value is scaled to 150 x 1.5 / 1.25 = 180: a Citizen (1.5) takes 120 s, a Citizen Hero (1.65) 109 s."
        }
      }
    },
    {
      "id": "village-center",
      "name": {
        "pt-BR": "Centro de Aldeia",
        "en": "Village Center"
      },
      "icon": "buildings/atlanteans-village-center",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 350,
        "gold": 350
      },
      "buildTime": 180,
      "popCap": 0,
      "age": "classical",
      "trains": ["citizen"],
      "researches": ["channels", "masons", "architects", "secrets-of-the-titans"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "No population. Enabled in the Archaic Age but shares the build limit of 1 with the Town Center until the Classical Age, so 'classical' here. The files have no train-rate penalty for it."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 150. Citizens build Settlements/Village Centers at rate 1.25 instead of their usual 1.5, so the value is scaled to 150 x 1.5 / 1.25 = 180: a Citizen (1.5) takes 120 s, a Citizen Hero (1.65) 109 s."
        }
      }
    },
    {
      "id": "manor",
      "name": {
        "pt-BR": "Mansão",
        "en": "Manor"
      },
      "icon": "buildings/atlanteans-manor",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 80,
        "gold": 20
      },
      "buildTime": 25,
      "popCap": 20,
      "limit": 8,
      "age": "archaic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Garrisons 2 foot units. Build limit 8. Kronos: Temporal Scaffolding (manor.tactics) - buildings within 20 m of a Manor build 25% faster."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 25 (time at build rate 1); one Citizen (1.5) takes 16.7 s, a Citizen Hero (1.65) 15.2 s."
        }
      }
    },
    {
      "id": "temple",
      "name": {
        "pt-BR": "Templo",
        "en": "Temple"
      },
      "icon": "buildings/atlanteans-temple",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "buildTime": 40,
      "age": "archaic",
      "trains": [
        "oracle",
        "promethean",
        "automaton",
        "caladria",
        "satyr",
        "behemoth",
        "stymphalian-bird",
        "argus",
        "centimanus",
        "lampades",
        "oracle-hero"
      ],
      "researches": [
        "temporal-chaos",
        "empyrian-speed",
        "alluvial-clay",
        "heart-of-the-titans",
        "hephaestus-revenge",
        "perception",
        "volcanic-forge",
        "gemini",
        "heroic-renewal",
        "sons-of-the-sun",
        "rheias-gift",
        "prophetic-sight",
        "guardian-of-io",
        "titanomachy",
        "asper-blood",
        "celerity",
        "mythic-rejuvenation",
        "channels",
        "omniscience"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Required for the Classical Age (AbstractTemple). Trains Oracle Heroes instead of Oracles after Sons of the Sun."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 40 (time at build rate 1); one Citizen (1.5) takes 26.7 s, a Citizen Hero (1.65) 24.2 s."
        }
      }
    },
    {
      "id": "economic-guild",
      "name": {
        "pt-BR": "Guilda Econômica",
        "en": "Economic Guild"
      },
      "icon": "buildings/atlanteans-economic-guild",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 50,
        "gold": 15
      },
      "buildTime": 15,
      "age": "archaic",
      "researches": [
        "husbandry",
        "hand-axe",
        "pickaxe",
        "plow",
        "plow-gaia",
        "survival-equipment",
        "survival-equipment-gaia",
        "bow-saw",
        "bow-saw-gaia",
        "shaft-mine",
        "shaft-mine-gaia",
        "irrigation",
        "irrigation-gaia",
        "carpenters",
        "carpenters-gaia",
        "quarry",
        "quarry-gaia",
        "flood-control",
        "flood-control-gaia",
        "theft-of-fire"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gaia: -35% cost."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 15 (time at build rate 1); one Citizen (1.5) takes 10.0 s, a Citizen Hero (1.65) 9.1 s."
        }
      }
    },
    {
      "id": "dock",
      "name": {
        "pt-BR": "Doca",
        "en": "Dock"
      },
      "icon": "buildings/atlanteans-dock",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 125
      },
      "buildTime": 30,
      "age": "archaic",
      "trains": [
        "fishing-ship",
        "transport-ship",
        "bireme",
        "fire-ship",
        "siege-bireme",
        "servant",
        "nereid",
        "man-o-war"
      ],
      "researches": [
        "purse-seine",
        "salt-amphora",
        "enclosed-deck",
        "heroic-fleet",
        "heavy-warships",
        "champion-warships",
        "conscript-sailors",
        "pioneer-of-the-skies",
        "daktyloi",
        "daughters-of-the-sea"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Drop site for Fishing Ships."
      },
      "fieldMeta": {
        "cost": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeAtlantean)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Dock wood cost Assign 125 (generic Dock proto 100)."
        },
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 30 (time at build rate 1); one Citizen (1.5) takes 20.0 s, a Citizen Hero (1.65) 18.2 s."
        }
      },
      "dropsiteFor": ["fish"]
    },
    {
      "id": "farm",
      "name": {
        "pt-BR": "Fazenda",
        "en": "Farm"
      },
      "icon": "buildings/atlanteans-farm",
      "pantheon": "atlanteans",
      "tags": ["farm"],
      "cost": {
        "wood": 150
      },
      "buildTime": 10,
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Infinite food source (see sources.json 'farm'). 400 HP for Atlanteans."
      },
      "fieldMeta": {
        "cost": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeAtlantean)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Farm wood cost Assign 150 (generic Farm proto 75); Farm hitpoints x2 BasePercent."
        },
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 10 (time at build rate 1); one Citizen (1.5) takes 6.7 s, a Citizen Hero (1.65) 6.1 s."
        }
      }
    },
    {
      "id": "counter-barracks",
      "name": {
        "pt-BR": "Contraquartel",
        "en": "Counter Barracks"
      },
      "icon": "buildings/atlanteans-counter-barracks",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 100,
        "gold": 25
      },
      "buildTime": 25,
      "age": "classical",
      "trains": ["katapeltes", "turma", "cheiroballista"],
      "researches": [
        "weightless-mace",
        "levy-counter-soldiers",
        "conscript-counter-soldiers",
        "frontline-heroics",
        "orichalcum-mail",
        "medium-infantry",
        "medium-ranged-soldiers",
        "heavy-infantry",
        "heavy-ranged-soldiers",
        "champion-infantry",
        "champion-ranged-soldiers"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml CounterBarracks buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 25 (time at build rate 1). A Citizen builds at 1.5, so one Citizen takes 16.7 s. The owner measured 25 s with one Citizen; the file wins (the measurement matched the buildpoints shown in the tooltip, not the real time)."
        }
      }
    },
    {
      "id": "military-barracks",
      "name": {
        "pt-BR": "Quartel Militar",
        "en": "Military Barracks"
      },
      "icon": "buildings/atlanteans-military-barracks",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 75,
        "gold": 35
      },
      "buildTime": 30,
      "age": "classical",
      "trains": ["murmillo", "arcus", "contarius"],
      "researches": [
        "bite-of-the-shark",
        "frontline-heroics",
        "orichalcum-mail",
        "poseidons-secret",
        "lance-of-stone",
        "levy-mainline-soldiers",
        "conscript-mainline-soldiers",
        "medium-infantry",
        "medium-ranged-soldiers",
        "heavy-infantry",
        "heavy-ranged-soldiers",
        "heavy-cavalry",
        "champion-infantry",
        "champion-ranged-soldiers",
        "champion-cavalry",
        "halo-of-the-sun"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 30 (time at build rate 1); one Citizen (1.5) takes 20.0 s, a Citizen Hero (1.65) 18.2 s."
        }
      }
    },
    {
      "id": "armory",
      "name": {
        "pt-BR": "Armaria",
        "en": "Armory"
      },
      "icon": "buildings/atlanteans-armory",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 150
      },
      "buildTime": 40,
      "age": "classical",
      "researches": [
        "copper-weapons",
        "copper-armor",
        "copper-shields",
        "ballistics",
        "bronze-weapons",
        "bronze-armor",
        "bronze-shields",
        "iron-weapons",
        "iron-armor",
        "iron-shields",
        "burning-pitch",
        "volcanic-forge",
        "bite-of-the-shark",
        "weightless-mace",
        "orichalcum-mail"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "One of the Heroic Age requirements (Armory or Market, OrPrereqs)."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 40 (time at build rate 1); one Citizen (1.5) takes 26.7 s, a Citizen Hero (1.65) 24.2 s."
        }
      }
    },
    {
      "id": "market",
      "name": {
        "pt-BR": "Mercado",
        "en": "Market"
      },
      "icon": "buildings/atlanteans-market",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 150
      },
      "buildTime": 40,
      "age": "classical",
      "trains": ["llama-caravan"],
      "researches": ["tax-collectors", "ambassadors", "coinage"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "One of the Heroic Age requirements (Armory or Market, OrPrereqs)."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 40 (time at build rate 1); one Citizen (1.5) takes 26.7 s, a Citizen Hero (1.65) 24.2 s."
        }
      }
    },
    {
      "id": "sentry-tower",
      "name": {
        "pt-BR": "Torre de Sentinela",
        "en": "Sentry Tower"
      },
      "icon": "buildings/atlanteans-sentry-tower",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "wood": 150,
        "gold": 100
      },
      "buildTime": 60,
      "limit": 30,
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "researches": [
        "watch-tower",
        "signal-fires",
        "crenellations",
        "guard-tower",
        "carrier-pigeons",
        "boiling-oil"
      ],
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 60 (time at build rate 1); one Citizen (1.5) takes 40.0 s, a Citizen Hero (1.65) 36.4 s."
        }
      }
    },
    {
      "id": "wooden-wall",
      "name": {
        "pt-BR": "Muralha de Madeira",
        "en": "Wooden Wall"
      },
      "icon": "buildings/atlanteans-wooden-wall",
      "pantheon": "atlanteans",
      "tags": ["defensive", "wall"],
      "cost": {
        "gold": 3
      },
      "buildTime": 5,
      "age": "archaic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Values for one wall connector. Short/Medium/Long segments: 6/9/15 gold, 6/9/15 s. Upgrades (Stone/Bronze/Iron/Orichalcum Wall) not included."
      },
      "researches": ["stone-wall"]
    },
    {
      "id": "palace",
      "name": {
        "pt-BR": "Palácio",
        "en": "Palace"
      },
      "icon": "buildings/atlanteans-palace",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 300,
        "gold": 300,
        "favor": 8
      },
      "buildTime": 115,
      "limit": 15,
      "age": "heroic",
      "trains": ["destroyer", "fanatic", "fire-siphon"],
      "researches": [
        "horns-of-consecration",
        "devotees-of-atlas",
        "titan-shield",
        "halo-of-the-sun",
        "petrification",
        "levy-palace-soldiers",
        "conscript-palace-soldiers",
        "draft-horses",
        "engineers",
        "advanced-fortifications",
        "frontline-heroics",
        "heroic-renewal",
        "medium-infantry",
        "heavy-infantry",
        "champion-infantry"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Fortress-type building; required for the Mythic Age (MythicAge* prereqs: Palace)."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml buildpoints)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "buildpoints 115 (time at build rate 1); one Citizen (1.5) takes 76.7 s, a Citizen Hero (1.65) 69.7 s."
        }
      }
    },
    {
      "id": "sky-passage",
      "name": {
        "pt-BR": "Passagem do Céu",
        "en": "Sky Passage"
      },
      "icon": "buildings/atlanteans-sky-passage",
      "pantheon": "atlanteans",
      "cost": {
        "wood": 25,
        "favor": 8
      },
      "buildTime": 30,
      "age": "archaic",
      "requires": ["oranos"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Oranos only (ArchaicAgeOranos Enable). Build limit 2, +1 per age (ClassicalAgeOranos/HeroicAgeOranos/MythicAgeOranos): 2/3/4/5; not set as 'limit' because it changes with the age."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "SkyPassage buildpoints 30 (base; a Citizen at 1.5 takes 20 s)."
        }
      }
    },
    {
      "id": "mirror-tower",
      "name": {
        "pt-BR": "Torre Espelho",
        "en": "Mirror Tower"
      },
      "icon": "buildings/atlanteans-mirror-tower",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "wood": 75,
        "gold": 50,
        "favor": 5
      },
      "buildTime": 60,
      "limit": 5,
      "age": "mythic",
      "requires": ["helios"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "MirrorTower buildpoints 60 (base; a Citizen at 1.5 takes 40 s)."
        }
      }
    },
    {
      "id": "hesperides-tree",
      "name": {
        "pt-BR": "Árvore de Hespérides",
        "en": "Hesperides Tree"
      },
      "icon": "buildings/atlanteans-hesperides-tree",
      "pantheon": "atlanteans",
      "tags": ["god-power"],
      "cost": {},
      "buildTime": 0,
      "age": "heroic",
      "requires": ["theia"],
      "trains": ["dryad"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not buildable: created by the Hesperides Tree god power (Theia), with 2 Dryads. Trains Dryads."
      }
    },
    {
      "id": "wonder",
      "name": {
        "pt-BR": "Maravilha",
        "en": "Wonder"
      },
      "icon": "buildings/atlanteans-wonder",
      "pantheon": "atlanteans",
      "cost": {
        "food": 5000,
        "wood": 5000,
        "gold": 5000
      },
      "buildTime": 5400,
      "limit": 1,
      "age": "mythic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not affected by Kronos' Manor build bonus (no LogicalTypeBuildingSmall/Large). Generates favor: AutoGather Favor 1.0/s = 60/min (proto.xml, autogather.tactics)."
      },
      "fieldMeta": {
        "buildTime": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Wonder buildpoints 5400 (base)."
        }
      },
      "trickle": {
        "favor": 60
      }
    }
  ],
  "researches": [
    {
      "id": "husbandry",
      "name": {
        "pt-BR": "Pecuária",
        "en": "Husbandry"
      },
      "icon": "techs/atlanteans-husbandry",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "time": 30,
      "at": "economic-guild",
      "age": "archaic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["herd"]
          },
          "note": "+10% herdable gather rate (also +25% fattening)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "hand-axe",
      "name": {
        "pt-BR": "Machado de Mão",
        "en": "Hand Axe"
      },
      "icon": "techs/atlanteans-hand-axe",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 120,
        "gold": 50
      },
      "time": 30,
      "at": "economic-guild",
      "age": "archaic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["wood"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "pickaxe",
      "name": {
        "pt-BR": "Picareta",
        "en": "Pickaxe"
      },
      "icon": "techs/atlanteans-pickaxe",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 50,
        "wood": 120
      },
      "time": 30,
      "at": "economic-guild",
      "age": "archaic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["gold"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "plow",
      "name": {
        "pt-BR": "Arado",
        "en": "Plow"
      },
      "icon": "techs/atlanteans-plow",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 50,
        "gold": 100
      },
      "time": 40,
      "at": "economic-guild",
      "age": "classical",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "plow-gaia",
      "name": {
        "pt-BR": "Arado",
        "en": "Plow"
      },
      "icon": "techs/atlanteans-plow-gaia",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 50,
        "gold": 100
      },
      "time": 40,
      "at": "economic-guild",
      "age": "archaic",
      "requires": ["gaia"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Same game tech as 'plow' (official name kept). Gaia's age techs make it obtainable one age earlier (ArchaicAgeGaia: Plow, Survival Equipment; ClassicalAgeGaia: Bow Saw, Shaft Mine, Irrigation; HeroicAgeGaia: Carpenters, Quarry, Flood Control)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. Same game tech as the non-Gaia one."
        }
      }
    },
    {
      "id": "survival-equipment",
      "name": {
        "pt-BR": "Equipamento de sobrevivência",
        "en": "Survival Equipment"
      },
      "icon": "techs/atlanteans-survival-equipment",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 100,
        "gold": 100
      },
      "time": 20,
      "at": "economic-guild",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Citizens +25% HP, +10% melee attack, +50% ranged (anti-animal) attack; no direct gather-rate effect modelled."
      }
    },
    {
      "id": "survival-equipment-gaia",
      "name": {
        "pt-BR": "Equipamento de sobrevivência",
        "en": "Survival Equipment"
      },
      "icon": "techs/atlanteans-survival-equipment-gaia",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 100,
        "gold": 100
      },
      "time": 20,
      "at": "economic-guild",
      "age": "archaic",
      "requires": ["gaia"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Same game tech as 'survival-equipment' (official name kept). Gaia's age techs make it obtainable one age earlier (ArchaicAgeGaia: Plow, Survival Equipment; ClassicalAgeGaia: Bow Saw, Shaft Mine, Irrigation; HeroicAgeGaia: Carpenters, Quarry, Flood Control)."
      }
    },
    {
      "id": "bow-saw",
      "name": {
        "pt-BR": "Arco de Serra",
        "en": "Bow Saw"
      },
      "icon": "techs/atlanteans-bow-saw",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 250,
        "gold": 150
      },
      "time": 45,
      "at": "economic-guild",
      "age": "heroic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.15,
          "scope": {
            "sources": ["wood"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "bow-saw-gaia",
      "name": {
        "pt-BR": "Arco de Serra",
        "en": "Bow Saw"
      },
      "icon": "techs/atlanteans-bow-saw-gaia",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 250,
        "gold": 150
      },
      "time": 45,
      "at": "economic-guild",
      "age": "classical",
      "requires": ["gaia"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.15,
          "scope": {
            "sources": ["wood"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Same game tech as 'bow-saw' (official name kept). Gaia's age techs make it obtainable one age earlier (ArchaicAgeGaia: Plow, Survival Equipment; ClassicalAgeGaia: Bow Saw, Shaft Mine, Irrigation; HeroicAgeGaia: Carpenters, Quarry, Flood Control)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. Same game tech as the non-Gaia one."
        }
      }
    },
    {
      "id": "shaft-mine",
      "name": {
        "pt-BR": "Poços de Mina",
        "en": "Shaft Mine"
      },
      "icon": "techs/atlanteans-shaft-mine",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 150,
        "wood": 250
      },
      "time": 40,
      "at": "economic-guild",
      "age": "heroic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.15,
          "scope": {
            "sources": ["gold"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "shaft-mine-gaia",
      "name": {
        "pt-BR": "Poços de Mina",
        "en": "Shaft Mine"
      },
      "icon": "techs/atlanteans-shaft-mine-gaia",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 150,
        "wood": 250
      },
      "time": 40,
      "at": "economic-guild",
      "age": "classical",
      "requires": ["gaia"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.15,
          "scope": {
            "sources": ["gold"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Same game tech as 'shaft-mine' (official name kept). Gaia's age techs make it obtainable one age earlier (ArchaicAgeGaia: Plow, Survival Equipment; ClassicalAgeGaia: Bow Saw, Shaft Mine, Irrigation; HeroicAgeGaia: Carpenters, Quarry, Flood Control)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. Same game tech as the non-Gaia one."
        }
      }
    },
    {
      "id": "irrigation",
      "name": {
        "pt-BR": "Irrigação",
        "en": "Irrigation"
      },
      "icon": "techs/atlanteans-irrigation",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 150,
        "gold": 250
      },
      "time": 30,
      "at": "economic-guild",
      "age": "heroic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "irrigation-gaia",
      "name": {
        "pt-BR": "Irrigação",
        "en": "Irrigation"
      },
      "icon": "techs/atlanteans-irrigation-gaia",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 150,
        "gold": 250
      },
      "time": 30,
      "at": "economic-guild",
      "age": "classical",
      "requires": ["gaia"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Same game tech as 'irrigation' (official name kept). Gaia's age techs make it obtainable one age earlier (ArchaicAgeGaia: Plow, Survival Equipment; ClassicalAgeGaia: Bow Saw, Shaft Mine, Irrigation; HeroicAgeGaia: Carpenters, Quarry, Flood Control)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. Same game tech as the non-Gaia one."
        }
      }
    },
    {
      "id": "carpenters",
      "name": {
        "pt-BR": "Carpinteiros",
        "en": "Carpenters"
      },
      "icon": "techs/atlanteans-carpenters",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 300,
        "gold": 200
      },
      "time": 55,
      "at": "economic-guild",
      "age": "mythic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "sources": ["wood"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "carpenters-gaia",
      "name": {
        "pt-BR": "Carpinteiros",
        "en": "Carpenters"
      },
      "icon": "techs/atlanteans-carpenters-gaia",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 300,
        "gold": 200
      },
      "time": 55,
      "at": "economic-guild",
      "age": "heroic",
      "requires": ["gaia"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "sources": ["wood"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Same game tech as 'carpenters' (official name kept). Gaia's age techs make it obtainable one age earlier (ArchaicAgeGaia: Plow, Survival Equipment; ClassicalAgeGaia: Bow Saw, Shaft Mine, Irrigation; HeroicAgeGaia: Carpenters, Quarry, Flood Control)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. Same game tech as the non-Gaia one."
        }
      }
    },
    {
      "id": "quarry",
      "name": {
        "pt-BR": "Pedreira",
        "en": "Quarry"
      },
      "icon": "techs/atlanteans-quarry",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 200,
        "wood": 300
      },
      "time": 50,
      "at": "economic-guild",
      "age": "mythic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "sources": ["gold"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "quarry-gaia",
      "name": {
        "pt-BR": "Pedreira",
        "en": "Quarry"
      },
      "icon": "techs/atlanteans-quarry-gaia",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 200,
        "wood": 300
      },
      "time": 50,
      "at": "economic-guild",
      "age": "heroic",
      "requires": ["gaia"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "sources": ["gold"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Same game tech as 'quarry' (official name kept). Gaia's age techs make it obtainable one age earlier (ArchaicAgeGaia: Plow, Survival Equipment; ClassicalAgeGaia: Bow Saw, Shaft Mine, Irrigation; HeroicAgeGaia: Carpenters, Quarry, Flood Control)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. Same game tech as the non-Gaia one."
        }
      }
    },
    {
      "id": "flood-control",
      "name": {
        "pt-BR": "Controle de Enchentes",
        "en": "Flood Control"
      },
      "icon": "techs/atlanteans-flood-control",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 250,
        "gold": 350
      },
      "time": 40,
      "at": "economic-guild",
      "age": "mythic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "flood-control-gaia",
      "name": {
        "pt-BR": "Controle de Enchentes",
        "en": "Flood Control"
      },
      "icon": "techs/atlanteans-flood-control-gaia",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 250,
        "gold": 350
      },
      "time": 40,
      "at": "economic-guild",
      "age": "heroic",
      "requires": ["gaia"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Same game tech as 'flood-control' (official name kept). Gaia's age techs make it obtainable one age earlier (ArchaicAgeGaia: Plow, Survival Equipment; ClassicalAgeGaia: Bow Saw, Shaft Mine, Irrigation; HeroicAgeGaia: Carpenters, Quarry, Flood Control)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. Same game tech as the non-Gaia one."
        }
      }
    },
    {
      "id": "theft-of-fire",
      "name": {
        "pt-BR": "Roubo do Fogo",
        "en": "Theft of Fire"
      },
      "icon": "techs/atlanteans-theft-of-fire",
      "pantheon": "atlanteans",
      "tags": ["myth-tech", "economic"],
      "cost": {
        "wood": 100,
        "favor": 12
      },
      "time": 30,
      "at": "economic-guild",
      "age": "classical",
      "requires": ["prometheus"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "ids": ["citizen-hero"]
          }
        },
        {
          "target": "buildRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "ids": ["citizen-hero"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Citizen Heroes +20% gather and build rate. Not available to Gaia (Gaia cannot pick Prometheus)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Gather (all) and Build ('Building' only) WorkRate x1.20 BasePercent on VillagerAtlanteanHero -> pct."
        }
      }
    },
    {
      "id": "purse-seine",
      "name": {
        "pt-BR": "Rede de Cerco",
        "en": "Purse Seine"
      },
      "icon": "techs/atlanteans-purse-seine",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 20,
      "at": "dock",
      "age": "classical",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "sources": ["fish"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "salt-amphora",
      "name": {
        "pt-BR": "Ânfora com Sal",
        "en": "Salt Amphora"
      },
      "icon": "techs/atlanteans-salt-amphora",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 200,
        "gold": 300
      },
      "time": 30,
      "at": "dock",
      "age": "heroic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "sources": ["fish"]
          },
          "note": "+50% fish gather rate, +25 carry capacity."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "enclosed-deck",
      "name": {
        "pt-BR": "Convés Fechado",
        "en": "Enclosed Deck"
      },
      "icon": "techs/atlanteans-enclosed-deck",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "wood": 200
      },
      "time": 40,
      "at": "dock",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heroic-fleet",
      "name": {
        "pt-BR": "Frota Heroica",
        "en": "Heroic Fleet"
      },
      "icon": "techs/atlanteans-heroic-fleet",
      "pantheon": "atlanteans",
      "tags": ["military", "myth-tech"],
      "cost": {
        "food": 100,
        "gold": 100,
        "favor": 10
      },
      "time": 20,
      "at": "dock",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heavy-warships",
      "name": {
        "pt-BR": "Navios de Guerra Pesados",
        "en": "Heavy Warships"
      },
      "icon": "techs/atlanteans-heavy-warships",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 20,
      "at": "dock",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "champion-warships",
      "name": {
        "pt-BR": "Navios de Guerra Campeões",
        "en": "Champion Warships"
      },
      "icon": "techs/atlanteans-champion-warships",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 250,
        "gold": 200
      },
      "time": 20,
      "at": "dock",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "conscript-sailors",
      "name": {
        "pt-BR": "Recrutar Marinheiros",
        "en": "Conscript Sailors"
      },
      "icon": "techs/atlanteans-conscript-sailors",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 300
      },
      "time": 30,
      "at": "dock",
      "age": "mythic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "tags": ["ship"]
          },
          "note": "Ship TrainPoints x0.80 Percent (-20% train time)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "masons",
      "name": {
        "pt-BR": "Pedreiros",
        "en": "Masons"
      },
      "icon": "techs/atlanteans-masons",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "food": 200,
        "wood": 300
      },
      "time": 20,
      "at": "town-center",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "architects",
      "name": {
        "pt-BR": "Arquitetos",
        "en": "Architects"
      },
      "icon": "techs/atlanteans-architects",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "food": 400,
        "wood": 500
      },
      "time": 30,
      "at": "town-center",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "fortified-town-center",
      "name": {
        "pt-BR": "Centro Urbano Fortificado",
        "en": "Fortified Town Center"
      },
      "icon": "techs/atlanteans-fortified-town-center",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "wood": 400,
        "gold": 400
      },
      "time": 60,
      "at": "town-center",
      "age": "heroic",
      "effects": [
        {
          "target": "popCap",
          "op": "add",
          "value": 10,
          "scope": {
            "ids": ["town-center"]
          },
          "note": "+10 population per Town Center (15 -> 25)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "temporal-chaos",
      "name": {
        "pt-BR": "Caos Temporal",
        "en": "Temporal Chaos"
      },
      "icon": "techs/atlanteans-temporal-chaos",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "wood": 100,
        "gold": 50,
        "favor": 10
      },
      "time": 20,
      "at": "temple",
      "age": "archaic",
      "requires": ["kronos"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Not expressible as modifiers: Time Shift duration ratio x0.5 (Percent) for every shiftable building, +1 concurrent shift (2 -> 3), shift cost ratio of Palace/Sentry Tower/Mirror Tower 0.50 -> 0.25 (x0.5 BasePercent)."
      }
    },
    {
      "id": "empyrian-speed",
      "name": {
        "pt-BR": "Velocidade Empírica",
        "en": "Empyrian Speed"
      },
      "icon": "techs/atlanteans-empyrian-speed",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 100,
        "favor": 5
      },
      "time": 30,
      "at": "temple",
      "age": "archaic",
      "requires": ["oranos"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Infantry +10% movement speed."
      }
    },
    {
      "id": "channels",
      "name": {
        "pt-BR": "Canais",
        "en": "Channels"
      },
      "icon": "techs/atlanteans-channels",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 100,
        "favor": 10
      },
      "time": 40,
      "at": "town-center",
      "age": "archaic",
      "requires": ["gaia"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Units move 15% faster on Lush. Also researchable at the Temple and Village Center. Researchable at the Town Center, Village Center and Temple (proto.xml)."
      }
    },
    {
      "id": "alluvial-clay",
      "name": {
        "pt-BR": "Argila Aluvial",
        "en": "Alluvial Clay"
      },
      "icon": "techs/atlanteans-alluvial-clay",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "food": 140,
        "favor": 10
      },
      "time": 30,
      "at": "temple",
      "age": "classical",
      "requires": ["prometheus"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heart-of-the-titans",
      "name": {
        "pt-BR": "Coração dos Titãs",
        "en": "Heart of the Titans"
      },
      "icon": "techs/atlanteans-heart-of-the-titans",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 50,
        "favor": 5
      },
      "time": 20,
      "at": "temple",
      "age": "classical",
      "requires": ["prometheus"],
      "effects": [
        {
          "target": "promotionTime",
          "op": "mul",
          "value": 0.25,
          "scope": {
            "tags": ["hero"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hero promotion time x0.25 (7 s -> 1.75 s)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml HeartOfTheTitans)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "HeroPromotion ResearchPoints x0.25 Percent -> mul (7 s -> 1.75 s)."
        }
      }
    },
    {
      "id": "hephaestus-revenge",
      "name": {
        "pt-BR": "Vingança de Hefesto",
        "en": "Hephaestus Revenge"
      },
      "icon": "techs/atlanteans-hephaestus-revenge",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 100,
        "favor": 10
      },
      "time": 20,
      "at": "temple",
      "age": "classical",
      "requires": ["leto"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "perception",
      "name": {
        "pt-BR": "Percepção",
        "en": "Perception"
      },
      "icon": "techs/atlanteans-perception",
      "pantheon": "atlanteans",
      "tags": ["myth-tech", "economic"],
      "cost": {
        "food": 50,
        "wood": 50
      },
      "time": 30,
      "at": "temple",
      "age": "classical",
      "requires": ["leto"],
      "effects": [
        {
          "target": "favorRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "ids": ["oracle", "oracle-hero"]
          },
          "note": "AutoGatherFavor FullCapacityMultiplier x1.10 BasePercent (adds with Prophetic Sight). Not modelled: Oracle LOS x1.10 and AutoLOS cap x1.10 BasePercent."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Oracles +10% LOS. Cost 50f 50w since 19.14612."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml Perception)",
          "checkedAt": "2026-10-18",
          "confidence": "medium",
          "note": "BasePercent -> pct. The LOS part has no modifier target, so the real gain at full LOS is a bit higher."
        }
      }
    },
    {
      "id": "volcanic-forge",
      "name": {
        "pt-BR": "Forja Vulcânica",
        "en": "Volcanic Forge"
      },
      "icon": "techs/atlanteans-volcanic-forge",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "food": 100,
        "gold": 50,
        "favor": 15
      },
      "time": 40,
      "at": "temple",
      "age": "classical",
      "requires": ["leto"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also researchable at the Armory."
      }
    },
    {
      "id": "bite-of-the-shark",
      "name": {
        "pt-BR": "Mordida do Tubarão",
        "en": "Bite of the Shark"
      },
      "icon": "techs/atlanteans-bite-of-the-shark",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "food": 100,
        "favor": 15
      },
      "time": 40,
      "at": "military-barracks",
      "age": "classical",
      "requires": ["oceanus"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also researchable at the Armory."
      }
    },
    {
      "id": "weightless-mace",
      "name": {
        "pt-BR": "Maça sem Peso",
        "en": "Weightless Mace"
      },
      "icon": "techs/atlanteans-weightless-mace",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 100,
        "wood": 75,
        "favor": 20
      },
      "time": 40,
      "at": "counter-barracks",
      "age": "classical",
      "requires": ["oceanus"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also researchable at the Armory."
      }
    },
    {
      "id": "frontline-heroics",
      "name": {
        "pt-BR": "Heroísmo da Linha de Frente",
        "en": "Frontline Heroics"
      },
      "icon": "techs/atlanteans-frontline-heroics",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 100,
        "favor": 12
      },
      "time": 40,
      "at": "military-barracks",
      "age": "classical",
      "requires": ["oceanus"],
      "effects": [
        {
          "target": "promotionCost",
          "op": "pct",
          "value": -0.2,
          "scope": {
            "ids": ["murmillo", "katapeltes", "destroyer", "fanatic"],
            "resources": ["food", "gold"]
          },
          "note": "HeroInfantry promotion techs (Murmillo, Katapeltes, Destroyer, Fanatic) food/gold cost x0.80 BasePercent. Not modelled: HeroInfantry unit cost x0.90."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Infantry hero promotion -20% food/gold cost. Also at Counter-Barracks and Palace."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml FrontlineHeroics)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "BasePercent -> pct; applied to the promotion cost (the engine prices a promotion with the hero unit id)."
        }
      }
    },
    {
      "id": "pioneer-of-the-skies",
      "name": {
        "pt-BR": "Pioneiro dos Céus",
        "en": "Pioneer of the Skies"
      },
      "icon": "techs/atlanteans-pioneer-of-the-skies",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "food": 50,
        "gold": 150,
        "favor": 15
      },
      "time": 40,
      "at": "dock",
      "age": "heroic",
      "requires": ["hyperion"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "gemini",
      "name": {
        "pt-BR": "Gêmeos",
        "en": "Gemini"
      },
      "icon": "techs/atlanteans-gemini",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "wood": 200,
        "favor": 15
      },
      "time": 40,
      "at": "temple",
      "age": "heroic",
      "requires": ["hyperion"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heroic-renewal",
      "name": {
        "pt-BR": "Renovação Heroica",
        "en": "Heroic Renewal"
      },
      "icon": "techs/atlanteans-heroic-renewal",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 125,
        "favor": 15
      },
      "time": 30,
      "at": "temple",
      "age": "heroic",
      "requires": ["hyperion"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also researchable at the Palace. 30 s since 19.14612. Also at the Palace (proto.xml)."
      }
    },
    {
      "id": "sons-of-the-sun",
      "name": {
        "pt-BR": "Filhos do Sol",
        "en": "Sons of the Sun"
      },
      "icon": "techs/atlanteans-sons-of-the-sun",
      "pantheon": "atlanteans",
      "tags": ["myth-tech", "economic"],
      "cost": {
        "gold": 200,
        "favor": 15
      },
      "time": 40,
      "at": "temple",
      "age": "heroic",
      "requires": ["hyperion"],
      "effects": [
        {
          "target": "favorRate",
          "op": "mul",
          "value": 1.44,
          "scope": {
            "ids": ["oracle"]
          },
          "note": "Approximation: every Oracle (existing and queued) becomes an Oracle Hero (TransformUnit), x1.44 favor."
        },
        {
          "target": "promotionCost",
          "op": "mul",
          "value": 0,
          "scope": {
            "ids": ["oracle"],
            "resources": ["favor"]
          },
          "note": "OracleHero favor cost Assign 0."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml SonsOfTheSun)",
          "checkedAt": "2026-10-18",
          "confidence": "medium",
          "note": "TransformUnit Oracle -> OracleHero (includequeued), OracleHero enabled and trained at the Temple instead of the Oracle, OracleHero favor cost 0."
        }
      }
    },
    {
      "id": "daktyloi",
      "name": {
        "pt-BR": "Dáctilo",
        "en": "Daktyloi"
      },
      "icon": "techs/atlanteans-daktyloi",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "food": 50,
        "wood": 100,
        "favor": 10
      },
      "time": 30,
      "at": "dock",
      "age": "heroic",
      "requires": ["rheia"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "horns-of-consecration",
      "name": {
        "pt-BR": "Chifres da Consagração",
        "en": "Horns of Consecration"
      },
      "icon": "techs/atlanteans-horns-of-consecration",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 150,
        "favor": 20
      },
      "time": 25,
      "at": "palace",
      "age": "heroic",
      "requires": ["rheia"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["fanatic"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Fanatics can be trained in the Heroic Age and train 20% faster. The age unlock is not expressible as a modifier."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "orichalcum-mail",
      "name": {
        "pt-BR": "Cota de Oricalco",
        "en": "Orichalcum Mail"
      },
      "icon": "techs/atlanteans-orichalcum-mail",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 175,
        "favor": 25
      },
      "time": 40,
      "at": "military-barracks",
      "age": "heroic",
      "requires": ["rheia"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also at Counter-Barracks and Armory."
      }
    },
    {
      "id": "rheias-gift",
      "name": {
        "pt-BR": "O Presente de Reia",
        "en": "Rheia's Gift"
      },
      "icon": "techs/atlanteans-rheias-gift",
      "pantheon": "atlanteans",
      "tags": ["myth-tech", "economic"],
      "cost": {
        "food": 75,
        "gold": 75
      },
      "time": 5,
      "at": "temple",
      "age": "heroic",
      "requires": ["rheia"],
      "effects": [
        {
          "target": "cost",
          "op": "pct",
          "value": -1,
          "scope": {
            "tags": ["myth-tech"],
            "resources": ["favor"]
          },
          "note": "Favor cost x0.00 BasePercent on all techs. Secrets of the Titans and hero promotions also get x2.00 BasePercent, so their favor cost is unchanged."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "RheiasGift: favor cost 0 for every tech except Secrets of the Titans and hero promotions (net unchanged); refunds favor already spent on techs (ResourceByKBStat totalTechCost, cap 2000), refund not modelled."
        }
      }
    },
    {
      "id": "daughters-of-the-sea",
      "name": {
        "pt-BR": "Filhas do mar",
        "en": "Daughters of the sea"
      },
      "icon": "techs/atlanteans-daughters-of-the-sea",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 150,
        "favor": 15
      },
      "time": 30,
      "at": "dock",
      "age": "heroic",
      "requires": ["theia"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "prophetic-sight",
      "name": {
        "pt-BR": "Visão Profética",
        "en": "Prophetic Sight"
      },
      "icon": "techs/atlanteans-prophetic-sight",
      "pantheon": "atlanteans",
      "tags": ["myth-tech", "economic"],
      "cost": {
        "food": 50,
        "gold": 100,
        "favor": 8
      },
      "time": 40,
      "at": "temple",
      "age": "heroic",
      "requires": ["theia"],
      "effects": [
        {
          "target": "favorRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "ids": ["oracle", "oracle-hero"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Oracles +10% favor generation; reveals enemy build queues in their LOS."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct. PropheticSight: AutoGatherFavor WorkRate x1.10 BasePercent on AbstractOracle. WorkRate is the 0.01/s base rate of the Oracle formula; whether it also scales the LOS term is not stated in the files (approximation)."
        }
      }
    },
    {
      "id": "poseidons-secret",
      "name": {
        "pt-BR": "Segredo de Poseidon",
        "en": "Poseidon's Secret"
      },
      "icon": "techs/atlanteans-poseidons-secret",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "food": 150,
        "favor": 30
      },
      "time": 40,
      "at": "military-barracks",
      "age": "heroic",
      "requires": ["theia"],
      "effects": [
        {
          "target": "cost",
          "op": "pct",
          "value": -0.1,
          "scope": {
            "tags": ["cavalry"]
          },
          "note": "AbstractCavalry food/wood/gold cost x0.90 BasePercent (-10%)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Cavalry +10% speed; hero promotion of cavalry cheaper."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "PoseidonsSecret: cost x0.90 BasePercent on AbstractCavalry and on the HeroCavalry promotion techs (Turma, Contarius); the engine prices promotions with the hero unit's tags, so both parts apply. Also cavalry speed x1.10."
        }
      }
    },
    {
      "id": "lance-of-stone",
      "name": {
        "pt-BR": "Lança de Pedra",
        "en": "Lance of Stone"
      },
      "icon": "techs/atlanteans-lance-of-stone",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 100,
        "favor": 12
      },
      "time": 40,
      "at": "military-barracks",
      "age": "heroic",
      "requires": ["theia"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "guardian-of-io",
      "name": {
        "pt-BR": "Guardião de Io",
        "en": "Guardian of Io"
      },
      "icon": "techs/atlanteans-guardian-of-io",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "food": 50,
        "gold": 200,
        "favor": 12
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["atlas"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "devotees-of-atlas",
      "name": {
        "pt-BR": "Devotos de Atlas",
        "en": "Devotees of Atlas"
      },
      "icon": "techs/atlanteans-devotees-of-atlas",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "food": 50,
        "gold": 100,
        "favor": 5
      },
      "time": 40,
      "at": "palace",
      "age": "mythic",
      "requires": ["atlas"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "titan-shield",
      "name": {
        "pt-BR": "Escudo dos Titãs",
        "en": "Titan Shield"
      },
      "icon": "techs/atlanteans-titan-shield",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "wood": 200,
        "gold": 75,
        "favor": 15
      },
      "time": 40,
      "at": "palace",
      "age": "mythic",
      "requires": ["atlas"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "halo-of-the-sun",
      "name": {
        "pt-BR": "Auréola do Sol",
        "en": "Halo of the Sun"
      },
      "icon": "techs/atlanteans-halo-of-the-sun",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 150,
        "favor": 20
      },
      "time": 40,
      "at": "palace",
      "age": "mythic",
      "requires": ["helios"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also at the Military Barracks. researchpoints 40 (was 50 from the wiki). Also at the Military Barracks."
      }
    },
    {
      "id": "petrification",
      "name": {
        "pt-BR": "Petrificação",
        "en": "Petrification"
      },
      "icon": "techs/atlanteans-petrification",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "wood": 150,
        "gold": 50,
        "favor": 10
      },
      "time": 40,
      "at": "palace",
      "age": "mythic",
      "requires": ["helios"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "titanomachy",
      "name": {
        "pt-BR": "Titanomaquia",
        "en": "Titanomachy"
      },
      "icon": "techs/atlanteans-titanomachy",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "food": 250,
        "favor": 20
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["helios"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "asper-blood",
      "name": {
        "pt-BR": "Sangue de Ásper",
        "en": "Asper Blood"
      },
      "icon": "techs/atlanteans-asper-blood",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 175,
        "favor": 12
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["hekate"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "celerity",
      "name": {
        "pt-BR": "Celeridade",
        "en": "Celerity"
      },
      "icon": "techs/atlanteans-celerity",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 200,
        "favor": 10
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["hekate"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "mythic-rejuvenation",
      "name": {
        "pt-BR": "Rejuvenescimento Mítico",
        "en": "Mythic Rejuvenation"
      },
      "icon": "techs/atlanteans-mythic-rejuvenation",
      "pantheon": "atlanteans",
      "tags": ["myth-tech"],
      "cost": {
        "gold": 150,
        "favor": 30
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["hekate"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "levy-mainline-soldiers",
      "name": {
        "pt-BR": "Convocar Soldados da Linha Principal",
        "en": "Levy Mainline Soldiers"
      },
      "icon": "techs/atlanteans-levy-mainline-soldiers",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 75,
        "wood": 75,
        "gold": 75
      },
      "time": 20,
      "at": "military-barracks",
      "age": "heroic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["murmillo", "arcus", "contarius"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "conscript-mainline-soldiers",
      "name": {
        "pt-BR": "Recrutar Soldados da Linha Principal",
        "en": "Conscript Mainline Soldiers"
      },
      "icon": "techs/atlanteans-conscript-mainline-soldiers",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 100,
        "wood": 100,
        "gold": 100
      },
      "time": 30,
      "at": "military-barracks",
      "age": "mythic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["murmillo", "arcus", "contarius"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "levy-counter-soldiers",
      "name": {
        "pt-BR": "Convocar Contrassoldados",
        "en": "Levy Counter Soldiers"
      },
      "icon": "techs/atlanteans-levy-counter-soldiers",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 75,
        "wood": 150
      },
      "time": 20,
      "at": "counter-barracks",
      "age": "heroic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["katapeltes", "turma", "cheiroballista"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "conscript-counter-soldiers",
      "name": {
        "pt-BR": "Recrutar Contra-Soldados",
        "en": "Conscript Counter Soldiers"
      },
      "icon": "techs/atlanteans-conscript-counter-soldiers",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 100,
        "wood": 200
      },
      "time": 20,
      "at": "counter-barracks",
      "age": "mythic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["katapeltes", "turma", "cheiroballista"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "levy-palace-soldiers",
      "name": {
        "pt-BR": "Convocar Soldados do Palácio",
        "en": "Levy Palace Soldiers"
      },
      "icon": "techs/atlanteans-levy-palace-soldiers",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 150
      },
      "time": 20,
      "at": "palace",
      "age": "heroic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["destroyer", "fanatic"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "conscript-palace-soldiers",
      "name": {
        "pt-BR": "Recrutar Soldados do Palácio",
        "en": "Conscript Palace Soldiers"
      },
      "icon": "techs/atlanteans-conscript-palace-soldiers",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 200
      },
      "time": 30,
      "at": "palace",
      "age": "mythic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["destroyer", "fanatic"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "medium-infantry",
      "name": {
        "pt-BR": "Infantaria Média",
        "en": "Medium Infantry"
      },
      "icon": "techs/atlanteans-medium-infantry",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 150,
        "gold": 150
      },
      "time": 20,
      "at": "military-barracks",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also at Counter-Barracks and Palace."
      }
    },
    {
      "id": "medium-ranged-soldiers",
      "name": {
        "pt-BR": "Soldados de Longo Alcance Médios",
        "en": "Medium Ranged Soldiers"
      },
      "icon": "techs/atlanteans-medium-ranged-soldiers",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 20,
      "at": "military-barracks",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also at Counter-Barracks."
      }
    },
    {
      "id": "heavy-infantry",
      "name": {
        "pt-BR": "Infantaria Pesada",
        "en": "Heavy Infantry"
      },
      "icon": "techs/atlanteans-heavy-infantry",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 300
      },
      "time": 30,
      "at": "military-barracks",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also at Counter-Barracks and Palace."
      }
    },
    {
      "id": "heavy-ranged-soldiers",
      "name": {
        "pt-BR": "Soldados de Longo Alcance Pesados",
        "en": "Heavy Ranged Soldiers"
      },
      "icon": "techs/atlanteans-heavy-ranged-soldiers",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 300,
        "gold": 300
      },
      "time": 30,
      "at": "military-barracks",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also at Counter-Barracks."
      }
    },
    {
      "id": "heavy-cavalry",
      "name": {
        "pt-BR": "Cavalaria Pesada",
        "en": "Heavy Cavalry"
      },
      "icon": "techs/atlanteans-heavy-cavalry",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 150
      },
      "time": 30,
      "at": "military-barracks",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Atlanteans get Heavy/Champion Cavalry 25% cheaper (wiki, update 17.43876): 400f 200g base -> 300f 150g. aomr-analyzer shows the undiscounted 400f 200g. Medium Cavalry is free for Atlanteans."
      },
      "fieldMeta": {
        "cost": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Base 400f 200g; ArchaicAgeAtlantean: food and gold x0.75 Percent -> 300f 150g."
        }
      }
    },
    {
      "id": "champion-infantry",
      "name": {
        "pt-BR": "Infantaria Campeã",
        "en": "Champion Infantry"
      },
      "icon": "techs/atlanteans-champion-infantry",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 500,
        "gold": 400
      },
      "time": 40,
      "at": "military-barracks",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also at Counter-Barracks and Palace."
      }
    },
    {
      "id": "champion-ranged-soldiers",
      "name": {
        "pt-BR": "Soldados de Longo Alcance Campeões",
        "en": "Champion Ranged Soldiers"
      },
      "icon": "techs/atlanteans-champion-ranged-soldiers",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 500,
        "gold": 400
      },
      "time": 40,
      "at": "military-barracks",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also at Counter-Barracks."
      }
    },
    {
      "id": "champion-cavalry",
      "name": {
        "pt-BR": "Cavalaria Campeã",
        "en": "Champion Cavalry"
      },
      "icon": "techs/atlanteans-champion-cavalry",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 525,
        "gold": 150
      },
      "time": 40,
      "at": "military-barracks",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "700f 200g base with the Atlantean -25% discount (wiki). aomr-analyzer shows 700f 200g."
      },
      "fieldMeta": {
        "cost": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Base 700f 200g; ArchaicAgeAtlantean: food and gold x0.75 Percent -> 525f 150g."
        }
      }
    },
    {
      "id": "copper-weapons",
      "name": {
        "pt-BR": "Armas de Cobre",
        "en": "Copper Weapons"
      },
      "icon": "techs/atlanteans-copper-weapons",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 100,
        "gold": 100
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "copper-armor",
      "name": {
        "pt-BR": "Armadura de Cobre",
        "en": "Copper Armor"
      },
      "icon": "techs/atlanteans-copper-armor",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 75,
        "gold": 75
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "copper-shields",
      "name": {
        "pt-BR": "Escudos de Cobre",
        "en": "Copper Shields"
      },
      "icon": "techs/atlanteans-copper-shields",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 75,
        "gold": 75
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "ballistics",
      "name": {
        "pt-BR": "Balística",
        "en": "Ballistics"
      },
      "icon": "techs/atlanteans-ballistics",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 50,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "bronze-weapons",
      "name": {
        "pt-BR": "Armas de Bronze",
        "en": "Bronze Weapons"
      },
      "icon": "techs/atlanteans-bronze-weapons",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 40,
      "at": "armory",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "bronze-armor",
      "name": {
        "pt-BR": "Armadura de Bronze",
        "en": "Bronze Armor"
      },
      "icon": "techs/atlanteans-bronze-armor",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 150
      },
      "time": 40,
      "at": "armory",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "bronze-shields",
      "name": {
        "pt-BR": "Escudos de Bronze",
        "en": "Bronze Shields"
      },
      "icon": "techs/atlanteans-bronze-shields",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 200,
        "gold": 150
      },
      "time": 40,
      "at": "armory",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "iron-weapons",
      "name": {
        "pt-BR": "Armas de Ferro",
        "en": "Iron Weapons"
      },
      "icon": "techs/atlanteans-iron-weapons",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 450,
        "gold": 450
      },
      "time": 50,
      "at": "armory",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "iron-armor",
      "name": {
        "pt-BR": "Armadura de Ferro",
        "en": "Iron Armor"
      },
      "icon": "techs/atlanteans-iron-armor",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 400,
        "gold": 400
      },
      "time": 50,
      "at": "armory",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "iron-shields",
      "name": {
        "pt-BR": "Escudos de Ferro",
        "en": "Iron Shields"
      },
      "icon": "techs/atlanteans-iron-shields",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 400,
        "gold": 350
      },
      "time": 50,
      "at": "armory",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "burning-pitch",
      "name": {
        "pt-BR": "Breu Incendiário",
        "en": "Burning Pitch"
      },
      "icon": "techs/atlanteans-burning-pitch",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "wood": 500,
        "gold": 300
      },
      "time": 40,
      "at": "armory",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "tax-collectors",
      "name": {
        "pt-BR": "Coletores de Impostos",
        "en": "Tax Collectors"
      },
      "icon": "techs/atlanteans-tax-collectors",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 35,
      "at": "market",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Better market exchange rates (not modelled)."
      }
    },
    {
      "id": "ambassadors",
      "name": {
        "pt-BR": "Embaixadores",
        "en": "Ambassadors"
      },
      "icon": "techs/atlanteans-ambassadors",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "gold": 250
      },
      "time": 30,
      "at": "market",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "coinage",
      "name": {
        "pt-BR": "Cunhagem",
        "en": "Coinage"
      },
      "icon": "techs/atlanteans-coinage",
      "pantheon": "atlanteans",
      "tags": ["economic"],
      "cost": {
        "gold": 200
      },
      "time": 40,
      "at": "market",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Caravans +20% speed."
      }
    },
    {
      "id": "draft-horses",
      "name": {
        "pt-BR": "Cavalos de Carga",
        "en": "Draft Horses"
      },
      "icon": "techs/atlanteans-draft-horses",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 200
      },
      "time": 40,
      "at": "palace",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "engineers",
      "name": {
        "pt-BR": "Engenheiros",
        "en": "Engineers"
      },
      "icon": "techs/atlanteans-engineers",
      "pantheon": "atlanteans",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 500
      },
      "time": 40,
      "at": "palace",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "advanced-fortifications",
      "name": {
        "pt-BR": "Fortificações Avançadas",
        "en": "Advanced Fortifications"
      },
      "icon": "techs/atlanteans-advanced-fortifications",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "wood": 600,
        "gold": 600
      },
      "time": 30,
      "at": "palace",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "watch-tower",
      "name": {
        "pt-BR": "Torre de Vigia",
        "en": "Watch Tower"
      },
      "icon": "techs/greeks-watch-tower",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "wood": 250,
        "gold": 150
      },
      "time": 15,
      "at": "sentry-tower",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Sentry Towers attack at range. Icon id borrowed from the Greek entry (same game icon)."
      }
    },
    {
      "id": "signal-fires",
      "name": {
        "pt-BR": "Fogueiras Sinalizadoras",
        "en": "Signal Fires"
      },
      "icon": "techs/greeks-signal-fires",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "wood": 150
      },
      "time": 30,
      "at": "sentry-tower",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "More line of sight for buildings. Icon id borrowed from the Greek entry (same game icon)."
      }
    },
    {
      "id": "crenellations",
      "name": {
        "pt-BR": "Ameias",
        "en": "Crenellations"
      },
      "icon": "techs/greeks-crenellations",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "food": 150,
        "wood": 150
      },
      "time": 20,
      "at": "sentry-tower",
      "age": "classical",
      "requires": ["watch-tower"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Requires Watch Tower. Icon id borrowed from the Greek entry (same game icon)."
      }
    },
    {
      "id": "guard-tower",
      "name": {
        "pt-BR": "Torre de Guarda",
        "en": "Guard Tower"
      },
      "icon": "techs/greeks-guard-tower",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "wood": 300,
        "gold": 300
      },
      "time": 40,
      "at": "sentry-tower",
      "age": "heroic",
      "requires": ["watch-tower"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Requires Watch Tower. Icon id borrowed from the Greek entry (same game icon)."
      }
    },
    {
      "id": "carrier-pigeons",
      "name": {
        "pt-BR": "Pombos Correio",
        "en": "Carrier Pigeons"
      },
      "icon": "techs/greeks-carrier-pigeons",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "wood": 400
      },
      "time": 45,
      "at": "sentry-tower",
      "age": "heroic",
      "requires": ["signal-fires"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Requires Signal Fires. Icon id borrowed from the Greek entry (same game icon)."
      }
    },
    {
      "id": "boiling-oil",
      "name": {
        "pt-BR": "Óleo Fervente",
        "en": "Boiling Oil"
      },
      "icon": "techs/greeks-boiling-oil",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "food": 100,
        "wood": 300
      },
      "time": 40,
      "at": "sentry-tower",
      "age": "heroic",
      "requires": ["watch-tower"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Requires Watch Tower. Icon id borrowed from the Greek entry (same game icon)."
      }
    },
    {
      "id": "stone-wall",
      "name": {
        "pt-BR": "Muralha de Pedra",
        "en": "Stone Wall"
      },
      "icon": "techs/greeks-stone-wall",
      "pantheon": "atlanteans",
      "tags": ["defensive"],
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 40,
      "at": "wooden-wall",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Researched at any wall piece. Bronze Wall (Classical), Iron Wall (Heroic) and Orichalcum Wall (Mythic) follow it but are not in the data yet (no icon in the manifest). Icon id borrowed from the Greek entry (same game icon)."
      }
    },
    {
      "id": "omniscience",
      "name": {
        "pt-BR": "Onisciência",
        "en": "Omniscience"
      },
      "icon": "techs/greeks-omniscience",
      "pantheon": "atlanteans",
      "tags": ["utility"],
      "cost": {
        "gold": 100
      },
      "time": 4,
      "at": "temple",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Reveals all enemy units. Dynamic cost: 100 gold per enemy unit (listed cost is per unit). Icon id borrowed from the Greek entry (same game icon)."
      }
    },
    {
      "id": "secrets-of-the-titans",
      "name": {
        "pt-BR": "Segredos dos Titãs",
        "en": "Secrets of the Titans"
      },
      "icon": "techs/egyptians-secrets-of-the-titans",
      "pantheon": "atlanteans",
      "tags": ["titan"],
      "cost": {
        "food": 800,
        "wood": 800,
        "gold": 800,
        "favor": 50
      },
      "time": 60,
      "at": "town-center",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml, proto.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Grants the Titan Gate god power. Also at the Village Center. Rheia's Gift does not change its favor cost. Icon id borrowed from the Egyptian entry (same game icon)."
      }
    }
  ],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, proto.xml, techtree.xml, god_powers/atlantean.godpowers, string tables)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Start (major_gods.xml): 275f 250w 75g; 2 Citizens (delay 2 s) + 3 Oracles (6/10/14 s), Gaia 2 Citizen Heroes instead; starting queue auto-trains Citizens. Pop cap 15 (Town Center populationcapaddition). Free units on age up for every Atlantean: Nereid (Heroic) and Man O' War (Mythic) at a Dock, if one exists. Sentry Towers come from the random map scripts."
  }
}
